/**
 * The "Details Needed by Smilepass" catalogue: what an FTC can ask the office
 * for — patient, insurance-policy and plan-member details — and the office
 * answers field by field (InfoAskReplyModal). Byte-identical with
 * clinics/services/info_ask_catalogue.json; the backend's test asserts it, so
 * change both or neither.
 */
import catalogue from "./infoAskCatalogue.json";

export const CATALOGUE = catalogue;
export const OTHER_KEY = catalogue.other.key;
export const OTHER_LABEL = catalogue.other.label;
export const ITEMS = catalogue.items.reduce(function (acc, item) {
  acc[item.key] = item;
  return acc;
}, {});
const ORDER = catalogue.items.map(function (item) { return item.key; });

/** The groups with their items, in catalogue order. */
export function catalogueGroups() {
  return catalogue.groups.map(function (group) {
    return Object.assign({}, group, {
      items: catalogue.items.filter(function (item) { return item.group === group.key; }),
    });
  });
}

export function itemFor(key) {
  return ITEMS[key] || null;
}

export function labelsFor(keys) {
  return (keys || []).map(function (key) { return ITEMS[key] ? ITEMS[key].label : null; }).filter(Boolean);
}

/** Catalogue keys, deduplicated, in catalogue order; unknown keys dropped. */
export function orderKeys(keys) {
  const wanted = {};
  (keys || []).forEach(function (key) { if (ITEMS[key]) wanted[key] = true; });
  return ORDER.filter(function (key) { return wanted[key]; });
}

/** "Needs Member date of birth, Group / Contract # and Other" — the server's
 *  `summary` when it sent one, else the same words from the fields. */
export function summaryFor(ask) {
  if (!ask) return "";
  if (ask.summary) return ask.summary;
  const parts = labelsFor((ask.fields || []).map(function (f) { return typeof f === "string" ? f : f.key; }));
  if (String(ask.other_text || "").trim()) parts.push(OTHER_LABEL);
  if (!parts.length) return "";
  if (parts.length === 1) return "Needs " + parts[0];
  return "Needs " + parts.slice(0, -1).join(", ") + " and " + parts[parts.length - 1];
}

// A blank critical policy field (lib/policyCompleteness) as the catalogue
// names it, so the FTC's checklist starts ticked with what is plainly missing.
const MISSING_TO_KEY = {
  first_name: "member.first_name",
  last_name: "member.last_name",
  member_id: "policy.member_id",
  contract_number: "policy.contract_number",
  date_of_birth: "member.date_of_birth",
  relation_to_member: "policy.relation_to_member",
};

export function keysForMissingCritical(missing) {
  return (missing || []).map(function (field) { return MISSING_TO_KEY[field]; }).filter(Boolean);
}
